import React, { Component } from "react";

import {plantsData} from '../data/plants'

export default class PlantList extends Component {
  // add state with a property called "plants" - initialize as an empty array
  constructor(){
    super();
    this.state = {
      plants: [],
      search: ''
    }
  }

  // when the component mounts:
  //   - fetch data from the server endpoint - http://localhost:3333/plants
  //   - set the returned plants array to this.state.plants
componentDidMount(){
  
    this.setState({
      plants: plantsData
    })

}

onChange = e => {
  this.setState({search : e.target.value})
}



  /*********  DON'T CHANGE ANYTHING IN THE RENDER FUNCTION *********/
  render() {
 

    return (
      <div>
        
      
      
      <main className="plant-list">
        <div className="formFilter">
          <input type="text"
            placeholder="Search Here" onChange={this.onChange}/>
        </div>
        {this.state.plants.filter(plant=> plant.name.toLowerCase().includes(this.state.search.toLowerCase())).map((plant) => (
          <div className="plant-card" key={plant.id}>
            <img className="plant-image" src={plant.img} alt={plant.name} />
            <div className="plant-details">
              <h2 className="plant-name">{plant.name}</h2>
              <p className="plant-scientific-name">{plant.scientificName}</p>
              <p>{plant.description}</p>
              <div className="plant-bottom-row">
                <p>${plant.price}</p>
                <p>☀️ {plant.light}</p>
                <p>💦 {plant.watering}x/month</p>
              </div>
              <button
                className="plant-button"
                onClick={() => this.props.addToCart(plant)}
              >
                Add to cart
              </button>
            </div>
          </div>
        ))}
      </main>
      </div>
    );
  }
}
